import { Action, createReducer, on } from '@ngrx/store';
import * as AuditActions from '@modules/audit/_store/actions/audit.action';

export const initialState = {
  companies: [],
  authors: [],
  info: null,
  documents: {},
  loaded: false,
  loading: false,
  error: null,
};

const loadAuditReducer = createReducer(
  initialState,
  on(AuditActions.loadNextAuditSuccess, (state, { payload, loaded }) => {
    const { info, documents } = payload;
    const {
      events: { analysis_module },
      ...rest
    } = info;
    return {
      ...state,
      info: { analysis_module, ...rest },
      documents,
      loaded,
      loading: false,
    };
  }),

  on(AuditActions.loadCompanies, (state, { companies }) => ({
    ...state,
    companies,
    loaded: true,
    loading: false,
  })),
  on(AuditActions.loadAuthors, (state, { authors }) => ({
    ...state,
    authors,
    loaded: true,
    loading: false,
  }))
);

export function reducer(state: any | undefined, action: Action) {
  return loadAuditReducer(state, action);
}

export const getAudit = (state) => state;
export const getCompanies = (state) => state?.companies;
export const getAuthors = (state) => state?.authors;
export const getAuditLoaded = (state) => state?.loaded;
export const getAuditLoading = (state) => state?.loading;
export const getAuditDocuments = (state) => state.documents;
export const getInfos = (state) => state.info;
